import { useEffect, useState } from "react";
import { getTimeLeftFromDateTime } from "~/utils/helper-funcations";

interface UseIsQuizLiveProps {
  date: string;
  startTime: string;
  isLiveFromServer?: boolean;
  onQuizStartTimeReached?: () => void; // Callback when quiz start time is reached
}

const useIsQuizLive = ({ date, startTime, isLiveFromServer = false, onQuizStartTimeReached }: UseIsQuizLiveProps) => {
  const [isQuizLive, setIsQuizLive] = useState(isLiveFromServer);
  const [remainingTime, setRemainingTime] = useState(getTimeLeftFromDateTime(date, startTime));
  const [hasQuizStartTimeReached, setHasQuizStartTimeReached] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const timeLeft = getTimeLeftFromDateTime(date, startTime);
      setRemainingTime(timeLeft);

      // Quiz is live if remaining time is <= 0
      if (timeLeft.totalSeconds <= 0) {
        setIsQuizLive(true);

        // If quiz start time just reached and server hasn't confirmed it's live
        // Trigger callback to refresh quiz data from server
        if (!hasQuizStartTimeReached && !isLiveFromServer) {
          setHasQuizStartTimeReached(true);
          if (onQuizStartTimeReached) {
            onQuizStartTimeReached();
          }
        }

        clearInterval(interval);
      } else {
        setIsQuizLive(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [date, startTime, isLiveFromServer, hasQuizStartTimeReached, onQuizStartTimeReached]);

  const isQuizStarted = remainingTime.totalSeconds <= 0 || isLiveFromServer;

  return {
    isQuizLive,
    isQuizStarted,
    remainingTime,
    hasQuizStartTimeReached,
  };
};

export default useIsQuizLive;
